import styled, { keyframes, css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const FlexDiv = styled.div({
    display: 'flex',
});

export const BrowseFileLabel = styled.label(({ theme }) => ({
    color: theme.colors.primary300,
    cursor: 'pointer',
    textDecoration: 'underline',
}));

export const CloudUploadIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.colors.neutral200,
    cursor: 'pointer',
    height: 42,
    marginRight: 8,
    width: 32,
}));

interface DropzoneProps {
    isDraggedOver?: boolean;
}
export const Dropzone = styled.div<DropzoneProps>(({ theme, isDraggedOver }) => ({
    alignItems: 'center',
    backgroundColor: isDraggedOver ? '#E5F1F8' : theme.colors.neutral000,
    border: isDraggedOver ? `2px solid ${theme.colors.primary300}` : `2px dashed ${theme.colors.neutral200}`,
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    height: 167,
    justifyContent: 'center',
    margin: 0,
    textAlign: 'center',
    width: 663,
}));

export const ErrorIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.colors.danger700,
    height: 42,
    width: 32,
}));

interface FilenameTextProps {
    isError?: boolean;
}
export const FilenameText = styled.p<FilenameTextProps>(({ theme, isError }) => ({
    color: isError ? theme.colors.danger700 : theme.colors.neutral900,
    fontSize: 15,
    lineHeight: '24px',
    marginTop: 20,
}));

export const UploadText = styled.p(({ theme }) => ({
    color: theme.colors.neutral900,
    fontSize: 15,
    lineHeight: '24px',
}));

export const Spinner = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.colors.primary700,
    fontSize: 35,
}));

export const ScanningText = styled.p(({ theme }) => ({
    color: theme.colors.neutral700,
    fontSize: 11,
    lineHeight: '16px',
}));

// Spinner component styles

interface SpinnerSVGProps {
    size: 'small' | 'large';
}
export const SpinnerSVG = styled.svg<SpinnerSVGProps>(({ size }) => ({
    width: size === 'small' ? 15 : 40,
    height: size === 'small' ? 15 : 40,
}));

const rotate = keyframes({
    '0%': {
        transform: 'rotate(0deg)',
    },
    '25%': {
        transform: 'rotate(520deg)',
    },
    '50%': {
        transform: 'rotate(180.6deg)',
    },
    '100%': {
        transform: 'rotate(1420deg)',
    },
});
const animation = css`
    ${rotate} 3s infinite ease;
`;

// @ts-ignore incorrect type definition?
export const SpinnerG = styled.g({
    transformOrigin: '50% 50%',
    animation,
});

// FileStatus component styles

interface ErrorProps {
    isError?: boolean;
}
export const FileStatusContainer = styled.div<ErrorProps>(({ theme, isError }) => ({
    alignItems: 'center',
    backgroundColor: theme.colors.neutral000,
    border: `1px solid ${theme.colors.neutral100}`,
    borderRadius: 2,
    boxSizing: 'border-box',
    color: isError ? theme.colors.danger700 : theme.colors.neutral900,
    display: 'flex',
    fontSize: 15,
    height: 32,
    justifyContent: 'space-between',
    marginBottom: 8,
    minHeight: 32,
    padding: '4px 8px',
}));

export const CheckIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.colors.success700,
}));

export const SmallErrorIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.colors.danger700,
}));

export const FileName = styled.p(({ theme }) => ({
    fontSize: 15,
    lineHeight: '15px',
    marginLeft: 12,
}));

export const FileStatusText = styled.p<ErrorProps>(({ theme, isError }) => ({
    color: isError ? theme.colors.danger700 : theme.colors.neutral700,
    fontSize: 11,
}));

export const FileSizeText = styled.p({
    fontWeight: 600,
    marginLeft: 12,
    fontSize: 11,
});

// FileStatuses component styles

export const StatusResultWrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    height: 406,
});

export const FileStatusesContainer = styled.div({
    backgroundColor: 'white',
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'auto',
    padding: 16,
    width: 600,
});

export const FileStatusesResult = styled.div(({ theme }) => ({
    alignItems: 'center',
    backgroundColor: 'white',
    border: `1px solid ${theme.colors.neutral100}`,
    display: 'flex',
    height: 48,
    justifyContent: 'center',
}));
